import React from 'react';
import './WhatsAppFloater.css';

const WhatsAppFloater = () => {
  const handleWhatsAppClick = () => {
    const whatsappNumber = '919599513613';
    const message = 'Hi, I would like to know more about your services.';
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <div className="whatsapp-floater">
      <button
        className="whatsapp-button"
        onClick={handleWhatsAppClick}
        title="Chat with us on WhatsApp"
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.148.547 4.262 1.586 6.142L0 24l6.374-2.138A11.962 11.962 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0m0 21.538c-2.031 0-4.027-.555-5.765-1.606l-.414-.242-4.286 1.444 1.468-4.167-.254-.401C1.751 15.425 1.31 13.75 1.31 12c0-5.697 4.631-10.33 10.33-10.33 2.758 0 5.352 1.074 7.308 3.024 1.956 1.95 3.034 4.543 3.034 7.306 0 5.697-4.632 10.33-10.332 10.33m5.676-7.768c-.309-.156-1.834-.907-2.118-1.01-.285-.103-.491-.154-.697.155-.206.31-.8 1.008-.98 1.215-.182.206-.363.231-.671.077-.309-.155-1.308-.482-2.493-1.538-.922-.848-1.544-1.894-1.725-2.203-.18-.31-.02-.476.136-.63.139-.137.31-.361.465-.541.155-.18.206-.31.309-.516.103-.206.052-.386-.026-.541-.078-.155-.697-1.68-.956-2.3-.253-.606-.508-.524-.697-.534-.18-.008-.386-.01-.593-.01-.206 0-.541.077-.824.386-.283.31-1.083 1.057-1.083 2.583 0 1.525 1.109 2.997 1.265 3.203.155.206 2.185 3.334 5.289 4.67.74.318 1.315.508 1.763.65.741.237 1.415.204 1.95.123.595-.089 1.83-.748 2.088-1.47.257-.723.257-1.343.18-1.47-.078-.126-.283-.206-.593-.361"/>
        </svg>
        <span className="whatsapp-text">Chat</span>
      </button>
    </div>
  );
};

export default WhatsAppFloater;
